<template>
  <!-- <div id="app">
    <router-view />
  </div> -->
  <div>
    <div>
      <ViewPanel v-if="urlType === 'detail'" />
      <PageList v-else-if="urlType === 'list'" />
    </div>
  </div>
</template>
<script>
import PageList from '@/views/PageList'
import ViewPanel from '@/views/ViewPanel'
import { getUrlParam } from '@/utils/fns'
export default {
  name: 'Jdata',
  components: {
    PageList,
    ViewPanel
  },
  data() {
    return {
      urlType: ''
    }
  },
  activated() {},
  mounted() {},
  created() {
    this.getUrl()
  },
  computed: {},
  methods: {
    getUrl() {
      const newType = getUrlParam('type')
      this.urlType = newType
    }
  }
}
</script>
